{
  "it": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Cambia fase",
        "reset_columns": "Reimposta colonne"
      },
      "labels": {
        "columns": "Colonne",
        "milestone": "Selezioni una nuova fase",
        "no_results": "Nessuna unità trovata"
      }
    }
  }
}
